export default __webpack_public_path__ + "static/media/btn_step_3_default.01aae0a2.svg";